import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { BackOfficeEnterpriseState } from './types';

export const initialState: BackOfficeEnterpriseState = null;

function backOfficeEnterpriseReducer(
  state: BackOfficeEnterpriseState = initialState,
  action: ApplicationActions
): BackOfficeEnterpriseState {
  switch (action.type) {
    case ActionTypes.SET_BACK_OFFICE_ENTERPRISE: {
      const {
        payload: { enterprise }
      } = action;

      return enterprise;
    }
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default backOfficeEnterpriseReducer;
